// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[data-v-2cb19a8e]::-webkit-outer-spin-button,\ninput[data-v-2cb19a8e]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"][data-v-2cb19a8e] {\n  -moz-appearance: textfield;\n}\n.emd-input-icon__link[data-v-2cb19a8e] {\n  top: -1px;\n}\n", ""]);
// Exports
module.exports = exports;
